import { render, staticRenderFns } from "./CheckboxSwitch.vue?vue&type=template&id=08042c5a&scoped=true"
import script from "./CheckboxSwitch.vue?vue&type=script&lang=js"
export * from "./CheckboxSwitch.vue?vue&type=script&lang=js"
import style0 from "./CheckboxSwitch.vue?vue&type=style&index=0&id=08042c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08042c5a",
  null
  
)

export default component.exports